import React from 'react';
import EMRHomeMedIcon from '../../../../assets/img/med-icons/emr-order-home-med.png';

const TimelineMedicationRequestHomeMedIcon = () => {
  return (
    <img
      src={EMRHomeMedIcon}
      style={{ width: '24px', transform: 'translateY(7px)' }}
      alt="EMR home med icon"
    />
  );
};

export default TimelineMedicationRequestHomeMedIcon;
